import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getProductMasterBySupplierIdApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const getProductMasterBySupplierId = createAsyncThunk('getProductMasterBySupplierId', async (payload) => {
  // console.log('payload', payload);
  return await getProductMasterBySupplierIdApi(payload);
});

const getProductMasterBySupplierIdSlice = createSlice({
  name: 'getProductMasterBySupplierId', // Unique Name
  initialState,
  reducers: {
    getProductMasterBySupplierIdReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProductMasterBySupplierId.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(getProductMasterBySupplierId.fulfilled, (state, action) => {
        const { message = '', data = [], payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(getProductMasterBySupplierId.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { getProductMasterBySupplierIdReset } = getProductMasterBySupplierIdSlice.actions;

export default getProductMasterBySupplierIdSlice.reducer;
